import { defineComponent, Ref, ref } from 'vue';
import { useGeoMultiMethodsStore } from '@/store/ps-management/geo-multi-methods.store';
import { AvailableAssociablePaymentMethodItem } from '@/models/ps-management/multi-methods.model';
import { storeToRefs } from 'pinia';
import FallbackImage from '@/components/fallback-image/fallback-image.vue';

export default defineComponent({
  name: 'AddMethodsDialog',
  components: {
    FallbackImage,
  },
  setup() {
    const geoMultiMethodsStore = useGeoMultiMethodsStore();
    const {
      availableAssociablePaymentMethodList,
      isAvailableAssociablePaymentMethodListLoading,
      isMethodListAssociatingDialogVisible,
    } = storeToRefs(geoMultiMethodsStore);

    const {
      closeMethodsAssociatingDialog,
      associateMethodsToMultiMethod,
    } = geoMultiMethodsStore;

    const selectedMethodList: Ref<AvailableAssociablePaymentMethodItem[]> = ref([]);

    const initiateSelectedMethodListAssociation = () => {
      associateMethodsToMultiMethod(selectedMethodList.value)
        .then(() => {
          selectedMethodList.value = [];
        });
    };

    const closeDialog = () => {
      closeMethodsAssociatingDialog();
      selectedMethodList.value = [];
    };

    return {
      selectedMethodList,
      isAvailableAssociablePaymentMethodListLoading,
      availableAssociablePaymentMethodList,
      isMethodListAssociatingDialogVisible,
      initiateSelectedMethodListAssociation,
      closeDialog,
    };
  },
});
